import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const featuredMovies = movies.filter((m) => m.featured);

export default function FeaturedSection() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading text-xl md:text-2xl text-foreground-900">精选推荐</h2>
        <Link
          to="/category/dianying"
          className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap transition-colors"
        >
          查看更多
          <div className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </div>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
        {featuredMovies.map((movie) => (
          <MovieCard
            key={movie.id}
            id={movie.id}
            title={movie.title}
            year={movie.year}
            rating={movie.rating}
            genre={movie.genre}
            posterUrl={movie.posterUrl}
            isNew={movie.isNew}
          />
        ))}
      </div>
    </section>
  );
}